import React, { useEffect, useState } from 'react'
import { useValue } from '../../../context/ContextProvider';
import { fetchMarcas } from '../../../actions/marcas';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Toolbar, Typography, } from '@mui/material';
import { DataGrid, GridToolbar, GridEventListener } from '@mui/x-data-grid';
import moment from 'moment'
import NuevaMarca from './NuevaMarca';
import MarcasActions from './MarcasActions';

const GestionMarcas = () => {
  /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
  const permisos = ['superusuario', 'administrador'];
  const [openNuevaMarca, setOpenNuevaMarca] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [rowOriginal, setRowOriginal] = useState(null);

  const navigate = useNavigate();
  const { state: { contextLoading, currentUser, marcas }, dispatch } = useValue();
  const [visibilidad, setVisibilidad] = useState(false);

  const [rowId, setRowId] = useState(null);

  //console.log('-------------->> components/marcas/Marcas.js');
  //console.log({ contextLoading, currentUser, marcas });

  useEffect(() => {
    //Renderiza la pagina al principio y cuando contextLoading cambia a falso. Código para hecho para refresh, cambio de páginas y autorizaciones
    /*
    if (marcas.length == 0 && !contextLoading && currentUser) {
      console.log('Solicitando Marcas al servidor.');
      fetchMarcas('todo', currentUser, dispatch);
    }
    */
    if (!contextLoading) {
      if (!permisos.includes(currentUser?.tipoUsuario)) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Página no autorizada! Redirecionando a Inicio.' } });
        navigate('/');
      } else {
        if (marcas.length == 0) {
          //console.log('Solicitando Marcas al servidor.');
          fetchMarcas('todo', currentUser, dispatch);
        }
        setVisibilidad(true);
      }
    }
  }, [contextLoading, currentUser]);



  const deleteRow = (rowToDelete) => {
    //console.log({ rowToDelete });
  }


  /* Configuración de columnas y datos a mostrar */
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 60,
      headerClassName: 'header-class'
    },
    {
      field: 'marca',
      headerName: 'Marca',
      width: 160,
      headerClassName: 'header-class'
    },
    {
      field: 'descripcion',
      headerName: 'Descripción',
      width: 260,
      headerClassName: 'header-class',
      editable: true
    },
    {
      field: 'timestamp',
      headerName: 'Fecha Creación',
      align: 'center',
      width: 120,
      headerClassName: 'header-class',
      renderCell: params => moment(params.row.timestamp).format('YYYY-MM-DD'),

    },
    {
      field: 'habilitado',
      headerName: 'Hab',
      width: 100,
      headerClassName: 'header-class',
      type: 'boolean',
      editable: true
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      type: 'actions',
      renderCell: (params) => <MarcasActions {...{ params, rowId, setRowId, deleteRow, table: 'marcas' }} />
    },
  ];

  /*********************/
  // Trabajando: analizar como enviar el update de una fila en 2 pasos, el primero para editar y el segundo para grabar la edición.

  //Elimina del array los resultados borrados, esto debería hacerse en la base de datos
  const rows = marcas.filter((marca) => marca.borrado == false);

  const handleRowDoubleClick = (params) => {
    //console.log(params.row);
    setIsUpdate(true);
    setRowOriginal(params.row);
    setOpenNuevaMarca(true);
  };

  const handleRowClick = (params) => {
    //console.log(params.row);
    setRowOriginal(params.row);
  };

  const handleNuevaMarca = () => {
    setIsUpdate(false);
    setOpenNuevaMarca(true);
  }

  const handleEditarMarca = () => {
    //console.log(rowOriginal);
    if (rowOriginal) {
      setIsUpdate(true);
      setOpenNuevaMarca(true);
    } else {
      dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'warning', message: 'Para editar debe seleccionar una marca en la tabla. Haciendo Click o Doble Click sobre la fila deseada.' } });
    }
  }

  const handleBorrarMarca = () => {
    //console.log(rowOriginal);
    if (rowOriginal) {
      //setIsUpdate(true);
      //setOpenNuevaMarca(true);
    } else {
      dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'warning', message: 'Para borrar debe seleccionar una marca en la tabla haciendo Click sobre la fila deseada y luego presionar el boton borrar.  Puede también utilizar el ícono presente encada fila.' } });
    }
  }

  const handleEdit = (params) => {
    const newMarcas = marcas.map((marca) => marca.id !== params.id ? marca : params);
    //console.log({ newMarcas });
    //dispatch({ type: 'UPDATE_USERS', payload: {rows: newUsers} });  //A users se envía el payload como {rows: valor}
    setRowId(params.id)
  }

  /* Función que arma la tabla */
  const tablaMarcas = () => (
    <>
      <DataGrid
        onRowDoubleClick={handleRowDoubleClick}
        onRowClick={handleRowClick}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        getRowHeight={() => 'auto'}
        sx={{}}
        slots={{ toolbar: GridToolbar, }}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              id: true,
              marca: true,
              ts: true,
            },
          }
        }}
        pageSizeOptions={[10, 20, 50]}

      />
    </>
  )




  return (
    <>
      {visibilidad ?
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
          spacing={0}
          justifyContent={{ lg: 'center' }}
          flexGrow={1} pt={2} pb={2}
        >
          <Box bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >
            <Typography variant="h5" component="h5" p={2} align='center'>
              Marcas
            </Typography>

            <Box m='auto' style={{ height: 600, maxWidth: '880px', backgroundColor: 'white' }}>
              {tablaMarcas()}
            </Box >

          </Box>
          <Box bgcolor='white' flex={4} padding={2} style={{ borderRadius: 0, width: '100%' }}>
            <Stack direction={'column'}>
              <Typography variant="h6" component="h5" p={2} align='center'>
                Gestión de datos
              </Typography>

              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Box width={'80%'} maxWidth={'400px'} sx={{ marginBottom: 2 }}>
                  <Button variant='outlined' fullWidth={true} onClick={handleEditarMarca}>Editar Marca</Button>
                </Box>
                <Box width={'80%'} maxWidth={'400px'}>
                  <Button variant='outlined' fullWidth={true} onClick={handleNuevaMarca}>Nueva Marca</Button>
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Stack>
        :
        <div>Página no autorizada.</div>

      }
      <NuevaMarca
        openNuevaMarca={openNuevaMarca}
        setOpenNuevaMarca={setOpenNuevaMarca}
        isUpdate={isUpdate}
        rowOriginal={rowOriginal}
        onCellEditStop={(params) => handleEdit(params)}
      />
    </>
  )
}

export default GestionMarcas